/**
 * Tricoci — capture UTMs + trackId, restore address bar BEFORE GTM / GA4 load.
 * Keep in sync with tricoci-booking-utm.js (UTM_KEYS, STORAGE_KEY, TRACK_ID_*).
 */
(function () {
  "use strict";

  if (window.__tricociBookingUtmEarlyDone) return;

  var STORAGE_KEY = "tricoci_landing_utms";
  var TRACK_ID_PARAM = "trackId";
  var TRACK_ID_STORAGE_KEY = "tricoci_track_id";
  var UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

  function readUtmsFromSearch(search) {
    var p = new URLSearchParams(search || "");
    var out = {};
    UTM_KEYS.forEach(function (key) {
      var val = (p.get(key) || "").trim();
      if (val) out[key] = val;
    });
    return out;
  }

  function readTrackIdFromSearch(search) {
    return (new URLSearchParams(search || "").get(TRACK_ID_PARAM) || "").trim();
  }

  function hasUtms(utms) {
    return !!(
      utms &&
      (utms.utm_source || utms.utm_medium || utms.utm_campaign || utms.utm_content || utms.utm_term)
    );
  }

  function storedUtms() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}") || {};
    } catch (e) {
      return {};
    }
  }

  function storedTrackId() {
    try {
      return sessionStorage.getItem(TRACK_ID_STORAGE_KEY) || "";
    } catch (e) {
      return "";
    }
  }

  function activeUtms() {
    return Object.assign({}, storedUtms(), readUtmsFromSearch(window.location.search));
  }

  function activeTrackId() {
    return readTrackIdFromSearch(window.location.search) || storedTrackId();
  }

  var fromUrl = readUtmsFromSearch(window.location.search);
  if (Object.keys(fromUrl).length) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign({}, storedUtms(), fromUrl)));
    } catch (e) {}
  }

  var trackIdFromUrl = readTrackIdFromSearch(window.location.search);
  if (trackIdFromUrl) {
    try {
      sessionStorage.setItem(TRACK_ID_STORAGE_KEY, trackIdFromUrl);
    } catch (e) {}
  }

  var utms = activeUtms();
  var trackId = activeTrackId();
  var needsUpdate = false;
  var url = new URL(window.location.href);

  if (hasUtms(utms)) {
    var currentUtms = readUtmsFromSearch(window.location.search);
    UTM_KEYS.forEach(function (key) {
      if (utms[key] && currentUtms[key] !== utms[key]) {
        url.searchParams.set(key, utms[key]);
        needsUpdate = true;
      }
    });
  }

  if (trackId && url.searchParams.get(TRACK_ID_PARAM) !== trackId) {
    url.searchParams.set(TRACK_ID_PARAM, trackId);
    needsUpdate = true;
  }

  if (needsUpdate) {
    history.replaceState(history.state, "", url.pathname + url.search + url.hash);
  }

  window.__tricociBookingUtmEarlyDone = true;
})();
